const getVersionSegements = (version: string|number): string[] => version.toString().split('.');
const parseVersionSegmentToInteger = (segment: string): number => parseInt(segment.replace(/[^\d.]/g, ''), 10);

const isVersionAtLeast = (specimen: string|number, control: string|number): boolean => {
    const specimenSegments = getVersionSegements(specimen);
    const controlSegments = getVersionSegements(control);
    const maxSegments = Math.min(controlSegments.length, specimenSegments.length);

    for (let i = 0; i < maxSegments; i++) {
        const controlSegment = parseVersionSegmentToInteger(controlSegments[i]);
        const specimenSegment = parseVersionSegmentToInteger(specimenSegments[i]);

        if (controlSegment < specimenSegment) {
            return true;
        } else if (controlSegment > specimenSegment) {
            return false;
        }
    }

    return true;
};

export default isVersionAtLeast;
